<template>
  <b-form-group
    label="Miktar"
    label-for="amount"
  >
    <validation-provider
      #default="{ errors }"
      name="Miktar"
      rules="required"
    >
      <b-input-group :append="'Adet'">
        <cleave
          id="amount"
          v-model="dataItem.amount"
          class="form-control"
          :raw="true"
          :options="options"
          placeholder="Giriniz"
        />

      </b-input-group>
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>
<script>
import { BFormGroup, BInputGroup } from 'bootstrap-vue'
import { required } from '@core/utils/validations/validations'
import Cleave from 'vue-cleave-component'
import { ValidationProvider, localize } from 'vee-validate'

export default {
  name: 'ProjectProductAmountCard',
  components: {
    ValidationProvider,
    BFormGroup,
    BInputGroup,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        numeral: true,
        numeralDecimalMark: ',',
        delimiter: '',
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['projectLines/dataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
